// extracted by mini-css-extract-plugin
module.exports = {"root":"ShippingAddressForm_root__1Bm8w","formRow":"ShippingAddressForm_formRow__M_PY7","field":"ShippingAddressForm_field__1wISZ","button":"ShippingAddressForm_button__2DVfY"};